<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo :titulo="locale[local].screen.documentos.string001" />
      <v-divider />

      <v-row justify="space-around">
        <v-col cols="12" md="8" lg="10" xl="9">
          <v-switch
            v-model="mostraTodos"
            :label="`Mostrar Todos`"
            @change="changedTodos"
          ></v-switch>
        </v-col>
      </v-row>

      <div class="ma-5">
        <v-card outlined elevation="0">
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="items"
              :items-per-page="10"
            >
              <template v-slot:[`item.doctoOrigem`]="{ item }">
                <div class="d-flex justify-center">
                  <v-btn
                    color="primary"
                    class="white--text"
                    small
                    :href="
                      'data:application/octet-stream;base64,' + item.doctoOrigem
                    "
                    :download="item.nomeArquivoOrigem"
                    width="200"
                    max-width="200"
                  >
                    <span>
                      {{ locale[local].screen.documentos.string002 }}
                    </span>
                    <v-icon right medium> mdi-printer </v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-slot:[`item.doctoAssinado`]="{ item }">
                <div v-if="!item.linkAssinatura" class="d-flex justify-center">
                  <v-btn
                    color="primary"
                    class="white--text"
                    small
                    :href="
                      'data:application/octet-stream;base64,' +
                      item.doctoAssinado
                    "
                    :download="item.nomeArquivoAssinado"
                    width="200"
                    max-width="200"
                  >
                    <span>
                      {{ locale[local].screen.documentos.string002 }}
                    </span>
                    <v-icon right medium> mdi-printer </v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-slot:[`item.linkAssinatura`]="{ item }">
                <div v-if="item.linkAssinatura" class="d-flex justify-center">
                  <v-btn
                    color="primary"
                    class="white--text"
                    small
                    :href="item.linkAssinatura"
                    target="_blank"
                    width="150"
                    max-width="150"
                  >
                    <span>
                      {{ locale[local].screen.documentos.string003 }}
                    </span>
                    <v-icon right medium> mdi-draw-pen </v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </div>
    </v-content>

    <v-card>
      <v-card-text>
        <v-overlay v-model="carregando">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card-text>
    </v-card>
  </v-app>
</template>

<script>
import Service from "../components/api/Service";
import moment from "moment";

export default {
  data: () => ({
    snackbar: false,
    loading: false,
    headers: [
      {
        text: "Sequência",
        value: "sequencia",
        divider: true,
      },
      {
        text: "Empresa",
        value: "codEmp",
        divider: true,
      },
      {
        text: "Empregado",
        value: "codEmpregado",
        divider: true,
      },
      {
        text: "Nome",
        value: "nome",
        divider: true,
      },
      {
        text: "Origem",
        value: "origem",
        divider: true,
      },
      {
        text: "Situação",
        value: "situacao",
        divider: true,
      },
      {
        text: "Competência",
        value: "dtCompetencia",
        divider: true,
      },
      // {
      //   text: "Documento Original",
      //   value: "doctoOrigem",
      //   align: "center",
      //   custom: true,
      //   divider: true,
      // },
      {
        text: "Documento Assinado",
        value: "doctoAssinado",
        align: "center",
        custom: true,
        divider: true,
      },
      {
        text: "Assinar Documento",
        value: "linkAssinatura",
        align: "center",
        custom: true,
        divider: true,
      },
    ],
    items: [],
    mostraTodos: false,
    carregando: false
  }),
  async mounted() {},
  created() {
    moment.locale("pt-br");
    this.buscarDocumentos(false);
  },
  methods: {
    async buscarDocumentos(tipo) {
      this.loading = true;
      this.carregando = true

      try {
        const service = new Service();
        this.items = await service.buscaDocumentos({
          codPessoa: parseInt(localStorage.getItem("codPessoa")),
          todos: tipo,
        });

        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
      finally{
        this.carregando = false
      }
    },
    changedTodos(valor) {
      if (valor === true) {
        this.buscarDocumentos(true);
      } else {
        this.buscarDocumentos(false);
      }
    },
  },
};
</script>
